import { Injectable } from '@angular/core';
import { SettingsState } from '@library/utils/interfaces/settings-state.interface';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap } from 'rxjs';
import { AirQualityService } from 'src/app/views/schedule-automations-view/room-automations-page/iaq-dashboard-view/iaq-dashboard-view.service';
import { GetAllHomeMeasures, GetAllHomeMeasuresFailure, GetAllHomeMeasuresSuccess, GetNotificationSettings, GetNotificationSettingsFailure, GetNotificationSettingsSuccess, SetNotificationSettings, SetNotificationSettingsSuccess } from './homes.action';
import { HomesServiceVelux } from './homes.service';
import { NotificationSettings } from './homes.interface';

@Injectable()
export class HomesEffectsVelux {
  constructor(
    private readonly homesService: HomesServiceVelux,
    private readonly actions$: Actions,
    private readonly store: Store<SettingsState>,
    private readonly airQualityService: AirQualityService,
  ) { }

  getNotificationSettings$ = createEffect(() => this.actions$.pipe(
    ofType(GetNotificationSettings),
    switchMap((action) => {
      return this.homesService.getHomeNotifications({ home_id: action.home_id }).pipe(
        map((notificationSettingsData: {notification_settings: Record<string, {NXG: NotificationSettings}>}) => GetNotificationSettingsSuccess({ notificationSettings: notificationSettingsData.notification_settings })),
        catchError(({ error }) => of(GetNotificationSettingsFailure({ error }))),
      );
    }),
  ));

  setNotificationSettings$ = createEffect(() => this.actions$.pipe(
    ofType(SetNotificationSettings),
    switchMap((action) => {
      const params = { settings: {} };
      params.settings[action.homeId] = { NXG: { ...action.notification_settings } };

      return this.homesService.setHomeNotifications(params).pipe(
        map(() => SetNotificationSettingsSuccess({ notificationSettings: action.notification_settings, homeId: action.homeId })),
        catchError(({ error }) => of(GetNotificationSettingsFailure({ error }))),
      );
    }),
  ));

  getAllHomeMeasures$ = createEffect(() => this.actions$.pipe(
    ofType(GetAllHomeMeasures),
    switchMap((params) => {
      return this.airQualityService.getAllMeasures(params).pipe(
        map((measures: number[][]) => {
          return GetAllHomeMeasuresSuccess({ measures, homeId: params['home_id'] });
        }),
        catchError(({ error }) => of(GetAllHomeMeasuresFailure({ error }))),
      );
    }),
  ));
}
